/**
 * Given a list of media files, uploads them one-by-one and returns
 * the resulting MediaAsset objects for the successful uploads. If any of the
 * files fail to upload, an alert is fired but no value for them
 * is returned.
 *
 * @param mediaFiles
 */

/**
  * Uploads the given media files to the server and returns an array of
  * MediaAsset objects for the successfully uploaded files.
  *
  * @param mediaFiles - An array of File objects to be uploaded.
  * @returns A promise that resolves to an array of MediaAsset objects.
  */
export default async (mediaFiles: File[] | undefined): Promise<MediaAsset[]> => {
  if (!mediaFiles) {
    return [];
  }

  const api = useApi();
  const toastAlerts = useToastAlerts();
  const mediaAssets: MediaAsset[] = [];
  for (const mediaFile of mediaFiles) {
    const data = new FormData();
    data.append('asset_file', mediaFile);
    data.append('asset_type', 'image');
    try {
      const response = await api.createMediaAsset(data);
      mediaAssets.push(response);
      toastAlerts.success(`Uploaded file: ${mediaFile.name}`);
    }
    catch (err) {
      // Log the failure, but keep going
      toastAlerts.warning(`Failed to upload file "${mediaFile.name}": ${(err as any).message}`);
    }
  }

  return mediaAssets;
};
